@if (isLoading()) {
  <app-shimmer-effect />
} @else {
  <section class="table-content">

    <div class="filters">
      <input
        (input)="getLevels('search', search)"
        [(ngModel)]="search"
        type="search"
        name="search"
        id="search"
        placeholder="Search name, username..."
      >

      <div>
        @if (loggedUserRole === 'SUPER_ADMIN' && schools() !== null) {
          <select
            (change)="getLevels('school_id', filterSchoolId)"
            [(ngModel)]="filterSchoolId"
            name="schoolId"
            id="schoolId"
          >
            <option value="" hidden disabled>Select a school</option>

            @for (s of schools()?.payload; track s.id) {
              <option [value]="s.id">
                {{ Helpers.capitalizeWords(s.school_name) }}
              </option>
            }
          </select>
        }

        <select
          (change)="getLevels('status', status)"
          [(ngModel)]="status"
          name="status"
          id="status"
        >
          <option value="" hidden disabled>Select a status</option>
          <option value="">All Statuses</option>

          <option value="ACTIVE">Active</option>
          <option value="INACTIVE">Inactive</option>
          <option value="ARCHIVED">Archived</option>
        </select>
      </div>
    </div>

    @if (loggedUserRole !== 'SUPER_ADMIN') {

      <div class="table-wrapper">
        <table>
          <thead>
          <tr>
            <th>LEVEL ID</th>
            <th>LEVEL NAME</th>
            <th>CODE</th>
            <th>STATUS</th>

            @if (loggedUserRole !== "FINANCE_ADMIN") {
              <th class="options-column">ACTIONS</th>
            }
          </tr>
          </thead>

          <tbody>
            @if (isFiltering()) {
              <tr>
                <td colspan="5">
                  <app-loading-indicator />
                </td>
              </tr>
            } @else {

              @if (!levels()?.payload?.length) {
                <tr>
                  <td colspan="5" class="empty">
                    <app-not-found-error>
                      NO LEVELS FOUND
                    </app-not-found-error>
                  </td>
                </tr>
              } @else {

                @for (u of levels()?.payload; track u.id) {
                  <tr>
                    <td>
                      {{ u.public_id }}
                    </td>

                    <td>
                      {{ u.name }}
                    </td>

                    <td class="level-code">
                      <p>{{ u.code }}</p>
                    </td>

                    <td class="status">
                      <p [ngClass]="u.status">
                        {{ Helpers.replaceUnderscore(u.status) }}
                      </p>
                    </td>

                    @if (loggedUserRole !== "FINANCE_ADMIN") {
                      <td class="options-column">
                        <app-action-button>
                          <button class="menu-item" (click)="navigateToLevelDetail(u.id)">View details</button>

                          @if (admins.includes(loggedUserRole)) {
                            <button class="menu-item" (click)="selectLevel('edit', u)">Edit level</button>

                            <button class="menu-item" (click)="selectLevel('status', u)">Change status</button>
                          }

                        </app-action-button>
                      </td>
                    }

                  </tr>
                }

              }
            }
          </tbody>
        </table>
      </div>

      <app-pagination
        [page]="levels()?.pagination?.page ?? 0"
        [size]="levels()?.pagination?.size ?? 10"
        [totalElements]="levels()?.pagination?.totalElements ?? 0"
        [totalPages]="levels()?.pagination?.totalPages ?? 0"
        [first]="levels()?.pagination?.first ?? true"
        [last]="levels()?.pagination?.last ?? false"
        [hasNext]="levels()?.pagination?.hasNext ?? false"
        [hasPrevious]="levels()?.pagination?.hasPrevious ?? false"
        (pageChange)="loadPage($event)"
      />

    } @else {

      <div class="table-wrapper">
        <table>
          <thead>
          <tr>
            <th>SCHOOL</th>
            <th>LEVEL ID</th>
            <th>LEVEL NAME</th>
            <th>CODE</th>
            <th>STATUS</th>
            <th class="options-column">ACTIONS</th>
          </tr>
          </thead>

          <tbody>
            @if (isFiltering()) {
              <tr>
                <td colspan="6">
                  <app-loading-indicator />
                </td>
              </tr>
            } @else {

              @if (!levels()?.payload?.length) {
                <tr>
                  <td colspan="6" class="empty">
                    <app-not-found-error>
                      NO LEVEL RECORDS FOUND
                    </app-not-found-error>
                  </td>
                </tr>
              } @else {

                @for (u of levels()?.payload; track u.id) {
                  <tr>
                    <td>{{ u.school_name }}</td>

                    <td>{{ u.public_id }}</td>

                    <td>{{ u.name }}</td>

                    <td class="level-code">
                      <p>{{ u.code }}</p>
                    </td>

                    <td class="status">
                      <p [ngClass]="u.status">
                        {{ Helpers.replaceUnderscore(u.status) }}
                      </p>
                    </td>

                    <td class="options-column">
                      <app-action-button>
                        <button class="menu-item" (click)="navigateToLevelDetail(u.id)">View details</button>

                        @if (admins.includes(loggedUserRole)) {
                          <button class="menu-item" (click)="selectLevel('edit', u)">Edit level</button>

                          <button class="menu-item" (click)="selectLevel('status', u)">Change status</button>
                        }
                      </app-action-button>
                    </td>
                  </tr>
                }

              }
            }
          </tbody>
        </table>
      </div>

      <app-pagination
        [page]="levels()?.pagination?.page ?? 0"
        [size]="levels()?.pagination?.size ?? 10"
        [totalElements]="levels()?.pagination?.totalElements ?? 0"
        [totalPages]="levels()?.pagination?.totalPages ?? 0"
        [first]="levels()?.pagination?.first ?? true"
        [last]="levels()?.pagination?.last ?? false"
        [hasNext]="levels()?.pagination?.hasNext ?? false"
        [hasPrevious]="levels()?.pagination?.hasPrevious ?? false"
        (pageChange)="loadPage($event)"
      />

    }

  </section>

  @if (changeStatus()) {
    <section class="pop-up">
      <div class="bg" (click)="changeStatus.set(false)"></div>

      <form #changeStatusForm="ngForm" (ngSubmit)="editLevelFn(changeStatusForm, 'status')">
        <div class="form-heading">
          <div class="image-box">
            <svg fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" enable-background="new 0 0 52 52"
                 xml:space="preserve" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <path
                d="M20,37.5c0-0.8-0.7-1.5-1.5-1.5h-15C2.7,36,2,36.7,2,37.5v11C2,49.3,2.7,50,3.5,50h15c0.8,0,1.5-0.7,1.5-1.5 V37.5z"></path>
                <path
                  d="M8.1,22H3.2c-1,0-1.5,0.9-0.9,1.4l8,8.3c0.4,0.3,1,0.3,1.4,0l8-8.3c0.6-0.6,0.1-1.4-0.9-1.4h-4.7 c0-5,4.9-10,9.9-10V6C15,6,8.1,13,8.1,22z"></path>
                <path
                  d="M41.8,20.3c-0.4-0.3-1-0.3-1.4,0l-8,8.3c-0.6,0.6-0.1,1.4,0.9,1.4h4.8c0,6-4.1,10-10.1,10v6 c9,0,16.1-7,16.1-16H49c1,0,1.5-0.9,0.9-1.4L41.8,20.3z"></path>
                <path
                  d="M50,3.5C50,2.7,49.3,2,48.5,2h-15C32.7,2,32,2.7,32,3.5v11c0,0.8,0.7,1.5,1.5,1.5h15c0.8,0,1.5-0.7,1.5-1.5 V3.5z"></path> </g></svg>
          </div>
          <div>
            <h6>Change Status</h6>
            <small>Updating status of {{ selectedLevel.name }}</small>
          </div>
        </div>

        <div class="form-container">
          <div class="status">
            <small>Current status:</small>
            <p [ngClass]="selectedLevel.status">{{ selectedLevel.status }}</p>
          </div>

          <div>
            <label for="newStatus">New Status <span class="required-check">*</span></label>
            <select required [(ngModel)]="newStatus" name="newStatus" id="newStatus">
              <option value="" hidden disabled>Select a status</option>

              @for (s of validStatuses; track $index) {
                @if (s !== selectedLevel.status) {
                  <option [value]="s">{{ Helpers.toSentenceCase(Helpers.replaceUnderscore(s)) }}</option>
                }
              }
            </select>
          </div>

          <button class="secondary-button" [disabled]="changeStatusForm.invalid" type="submit">
            @if (isEditing()) {
              <app-loading-indicator></app-loading-indicator>
            } @else {
              Change status
            }
          </button>

        </div>
      </form>
    </section>
  }

  @if (editLevel()) {
    <section class="pop-up">
      <div class="bg" (click)="editLevel.set(false)"></div>

      <form #editLevelForm="ngForm" (ngSubmit)="editLevelFn(editLevelForm, 'edit')">
        <div class="form-heading">
          <div class="image-box">
            <svg height="200px" width="200px" version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier"> <style type="text/css"> .st0 {
                fill: #fff;
              } </style>
                <g> <path class="st0"
                          d="M81.44,116.972c23.206,0,42.007-18.817,42.007-42.008c0-23.215-18.801-42.016-42.007-42.016 c-23.216,0-42.016,18.801-42.016,42.016C39.424,98.155,58.224,116.972,81.44,116.972z"></path>
                  <path class="st0"
                        d="M224.166,245.037c0-0.856-0.142-1.673-0.251-2.498l62.748-45.541c3.942-2.867,4.83-8.411,1.963-12.362 c-1.664-2.285-4.342-3.652-7.17-3.652c-1.877,0-3.667,0.589-5.191,1.689l-62.874,45.636c-2.341-1.068-4.909-1.704-7.65-1.704 h-34.178l-8.294-47.222c-4.555-23.811-14.112-42.51-34.468-42.51h-86.3C22.146,136.873,0,159.019,0,179.383v141.203 c0,10.178,8.246,18.432,18.424,18.432c5.011,0,0,0,12.864,0l7.005,120.424c0,10.83,8.788,19.61,19.618,19.61 c8.12,0,28.398,0,39.228,0c10.83,0,19.61-8.78,19.61-19.61l9.204-238.53h0.463l5.27,23.269c1.744,11.097,11.293,19.28,22.524,19.28 h51.534C215.92,263.461,224.166,255.215,224.166,245.037z M68.026,218.861v-67.123h24.126v67.123l-12.817,15.118L68.026,218.861z"></path>
                  <polygon class="st0"
                           points="190.326,47.47 190.326,200.869 214.452,200.869 214.452,71.595 487.874,71.595 487.874,302.131 214.452,302.131 214.452,273.113 190.326,273.113 190.326,326.256 512,326.256 512,47.47 "></polygon>
                  <path class="st0"
                        d="M311.81,388.597c0-18.801-15.235-34.029-34.028-34.029c-18.801,0-34.036,15.228-34.036,34.029 c0,18.785,15.235,34.028,34.036,34.028C296.574,422.625,311.81,407.381,311.81,388.597z"></path>
                  <path class="st0"
                        d="M277.781,440.853c-24.259,0-44.866,15.919-52.782,38.199h105.565 C322.648,456.771,302.04,440.853,277.781,440.853z"></path>
                  <path class="st0"
                        d="M458.573,388.597c0-18.801-15.235-34.029-34.028-34.029c-18.801,0-34.036,15.228-34.036,34.029 c0,18.785,15.235,34.028,34.036,34.028C443.338,422.625,458.573,407.381,458.573,388.597z"></path>
                  <path class="st0"
                        d="M424.545,440.853c-24.259,0-44.866,15.919-52.783,38.199h105.565 C469.411,456.771,448.804,440.853,424.545,440.853z"></path> </g> </g></svg>
          </div>

          <div>
            <h6>Edit Level</h6>
            <small>Update the details of {{ selectedLevel.name }}</small>
          </div>
        </div>

        <div class="form-container">
          <div>
            <label for="nameOfLevel">Name of Level <span class="required-check">*</span></label>
            <input placeholder="e.g.  Primary 4" required [(ngModel)]="nameOfLevel" type="text" name="nameOfLevel"
                   id="nameOfLevel">
          </div>

          <div>
            <label for="levelCode">Level Code <span class="required-check">*</span></label>
            <input placeholder="e.g.  PRI04" required [(ngModel)]="levelCode" type="text" name="levelCode"
                   id="levelCode">
          </div>

          <div>
            <label for="levelSequence">Level Sequence <span class="required-check">*</span></label>
            <input placeholder="Select a numbered order for this level. e.g. 1" required [(ngModel)]="levelSequence"
                   type="number" name="levelSequence" id="levelSequence">
          </div>

          <div>
            <label for="levelDescription">Description</label>
            <input placeholder="e.g.  Add an optional description..." [(ngModel)]="levelDescription" type="text"
                   name="levelDescription" id="levelDescription">
          </div>

          <button class="secondary-button" type="submit" [disabled]="editLevelForm.invalid">
            @if (isEditing()) {
              <app-loading-indicator></app-loading-indicator>
            } @else {
              Edit Level
            }
          </button>
        </div>
      </form>
    </section>
  }

  @if (admins.includes(loggedUserRole) && levels() !== null && !levels()?.payload?.length && generateLevels()) {
    <section class="generator">
      <div class="bg" (click)="generateLevels.set(false)"></div>

      <div class="generator-container">
        <h6>Would you like to generate all levels from Creche to Basic 9?</h6>

        <div class="generator-buttons">
          <button class="button" (click)="generateLevels.set(false)">Cancel</button>
          <button class="secondary-button" (click)="generateLevelsFn()">
            @if (isGenerating()) {
              <app-loading-indicator />
            } @else {
              Generate
            }
          </button>
        </div>
      </div>
    </section>
  }

}

@if (levels() !== null && !levels()?.payload?.length) {
  <button (click)="generateLevels.set(true)" class="gen-levels-btn">
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M6 12H18M12 6V18" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
      </g>
    </svg>
  </button>
}
